import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateSuppProfileProps } from '../../../stores/profile/company/profile-actions';
import { TextField } from 'material-ui';
import R from 'ramda';

const SearchBar = props => {
  const {
    locOrProd,
    profileReducer,
    updateProp,
    allLocOrProd,
    prodType,
  } = props;

  return (
    <div style={{ margin: '5px' }}>
      <TextField
        style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', maxHeight: '34px' }}
        inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' }}
        underlineShow={false}
        value={R.propOr('', 'searchValue', profileReducer)}
        onChange={({ target: { value } }) => updateProp({
          searchValue: value,
          filteredResults: allLocOrProd.filter(item => R.contains(value.toLowerCase(), item.name.toLowerCase())),
        })}
        hintText={`Search for a ${locOrProd === 'location' && prodType === 'Accommodation' ? 'Property' : locOrProd}...`}
        hintStyle={{ marginLeft: '5px', lineHeight: '34px', top: '-1px' }}
      />
    </div>
  );
};

SearchBar.propTypes = {
  allLocOrProd: PropTypes.array,
  profileReducer: PropTypes.object,
  updateProp: PropTypes.func,
  locOrProd: PropTypes.string,
  prodType: PropTypes.string,
};

const mapStateToProps = ({ profile, user }) => ({
  profileReducer: profile.toJS(),
  prodType: user.getIn(['company', 'productType']),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateSuppProfileProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/locProdSearchBar.jsx